import type { Store } from '../../data/types';

/**
 * A DM (or anyone but the store team) completing a task assigned to the
 * store's shared account — owner ruling 2026-10-25: allowed, with a
 * confirm first ("Complete this on the store's behalf?"). Trimmed +
 * case-insensitive address compares (scope.ts convention).
 */
export function completesOnStoreBehalf(
  task: { assignedTo: string },
  store: Pick<Store, 'managerEmail'> | null | undefined,
  user: { upn: string; role: string } | null | undefined,
): boolean {
  if (!user || user.role === 'StoreTeam' || !store) return false;
  const assignee = task.assignedTo.trim().toLowerCase();
  const account = store.managerEmail.trim().toLowerCase();
  return assignee !== '' && assignee === account && assignee !== user.upn.trim().toLowerCase();
}

export const ON_BEHALF_CONFIRM =
  'This task is assigned to the store. Complete it on the store’s behalf?';
